var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "d-flex": _vm.horizontal } },
    _vm._l(_vm.options, function(item) {
      return _c(
        "div",
        {
          key: item.id,
          class: { "mt-1 mr-4": _vm.horizontal, "mt-3": !_vm.horizontal }
        },
        [
          _c(
            "b-form-radio",
            {
              staticClass: "custom-radio",
              attrs: {
                checked: _vm.checked,
                disabled: _vm.isReadOnly,
                size: "lg",
                value: item.id
              },
              on: { input: _vm.onSelect }
            },
            [_vm._v(" " + _vm._s(item.name) + " ")]
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }